export const constants = {
  INIT_VARIABLES: 'INIT_VARIABLES',
  SET_FILE: 'SET_FILE',
  VERIFY_DOCUMENT: 'VERIFY_DOCUMENT',
  UPDATE_VALUE: 'UPDATE_VALUE'
};
